module.exports = __webpack_public_path__ + "static/media/fees-mtc.c55f2f19.svg";